<div class="align-container">

  <lib-icon-view *ngIf="config?.icon" [view]="config?.icon"
                 [class.icon-end]="config?.icon?.position === 'end'">
  </lib-icon-view>

  <img *ngIf="config?.image?.src"
       [src]="config?.image?.src"
       [style.height]="config?.image?.height"
       [style.width]="config?.image?.width"
       alt="img">

  <!-- MatTooltip создаётся только когда тултип задан: пустая директива на каждой ячейке слишком дорога -->
  <ng-container *ngIf="config?.text?.show != false">
    <span *ngIf="config?.text?.tooltip as tooltip; else plainText"
          [matTooltip]="tooltip"
          [matTooltipPosition]="config?.text?.tooltipPosition || 'below'"
          [style.color]="config?.text?.color">
       {{ value }}
    </span>
    <ng-template #plainText>
      <span [style.color]="config?.text?.color">
       {{ value }}
      </span>
    </ng-template>
  </ng-container>
</div>
